<template>
  <div class="ui-toast-component-wrapper">
    <div class="ui-toast-component" :class="type">
      <div class="toast-icon" :class="type">
        <i class="fa-solid" :class="typeIcon" />
      </div>
      <div class="toast-message" v-text="message" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { IToast } from '@/types/Components/Popup'
  import { computed } from 'vue'

  const { type = 'success', message } = defineProps<IToast>()

  const typeIcon = computed((): string => {
    switch (type) {
      case 'success':
        return 'fa-circle-check'
      case 'danger':
        return 'fa-circle-xmark'
      case 'warning':
        return 'fa-circle-exclamation'
      case 'info':
        return 'fa-circle-info'
      default:
        return ''
    }
  })
</script>

<style lang="scss">
  .ui-toast-component-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 9999;
    @include flexible($justify: center, $align: center);
    pointer-events: none;
    top: -5rem;
    animation: fadein 0.55s forwards;
    overflow: hidden;
    @keyframes fadein {
      from {
        top: -5rem;
      }
      to {
        top: 1rem;
      }
    }

    .ui-toast-component {
      @include flexible($justify: center, $align: center);
      border-radius: 5px;
      padding: 1rem;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      &.success {
        background-color: $success;
      }
      &.danger {
        background-color: $danger;
      }
      &.warning {
        background-color: $warning;
      }
      &.info {
        background-color: $info;
      }
      .toast-icon {
        margin-right: 1rem;
        font-size: 1.5rem;
        font-weight: bold;
        color: $white;
      }
      .toast-message {
        font-size: 1.2rem;
        font-weight: 500;
        color: #fff;
      }
      @include media(xs, sm, md) {
        width: calc(100% - 2rem);
        justify-content: flex-start;
        .toast-message {
          font-size: 1rem;
        }
        .toast-icon {
          font-size: 1.25rem;
        }
      }
    }
  }
</style>
